class SfWebhooksCtrl {
  constructor(FEService, SFService, SchemaService, FormBuilderService, AuthService, TemplateService, $scope, $window) {
    'ngInject';
    this.fe = FEService;
    this.as = AuthService;
    this.fbs = FormBuilderService;
    this.ss = SchemaService;
    this.sf = SFService;
    this.ts = TemplateService;
    this.$scope = $scope;
    this.$window = $window;
    this.provider = 'Data Provider';
    this.tables = [];
    this.table = {};
    this.sourceFields = {};
    this.messages = [];
    this.loading = false;
  }

  cancel() {
    this.onCancel();
  }

  async $onInit() {
    try {
      [this.td, this.provider, this.tables] = await Promise.all([
        this.ts.getTemplateData(),
        this.as.provider(),
        this.ss.getGrantedDBs()
      ]);
      this.templateId = this.ts.templateId;
    } catch (error) {
      this.handleMessage({ error, when: "During Page Setup" });
    }
  }

  async fetchFields(tableId) {
    const res = await this.ss.getSchema(this.td.template, tableId);
    const { fields } = res;
    return fields;
  }

  async tableSelected(tableId) {
    this.sourceFields = {};
    this.sourceFields = await this.ss.getSchema(this.td.template, tableId);
  }

  async add() {

    this.loading = true;
    this.messages = [];

    if (!this.$window.confirm("Adding a webhook will prevent the addition and removal of Target Tables. \nThe template will be updated in the provider and a new business rule will be created.\nContinue?")) {
      // this.onCancel();
      return;
    }

    // Register trigger
    this.fbs.exportTemplate(this.td.template, true)
      .then(response => {
        if (response.data.success == true) {
          this.handleMessage({ message: 'The template was updated on the provider successfully! Registering trigger...', alertClass: 'success' });
          this.sf.addTemplateHook(this.templateId, (this.reference || {}).id, (this.reference || this.table).tableId, (this.sourceField || {}).id, this.hookType, this.triggerType)
            .then(response => {
              if (response.data == true) {
                this.handleMessage({ message: 'The trigger was registered in the provider!', alertClass: 'success' });
              }
              else {
                this.handleMessage({ message: 'First make sure the tamplate was migrated to the provider!', alertClass: 'danger' });
              }
              this.loading = false;
            }, response => {
              this.handleMessage({ message: 'There was an error registering trigger on the provider!', alertClass: 'danger' });
              this.loading = false;
            });
        }
        else if (response.data.success == false) {
          this.handleMessage({ message: 'The template hasn\'t been exported for the first time!', alertClass: 'info' });
        }
        else {
          this.handleMessage({ message: 'There was an error updating the template on the provider!', alertClass: 'danger' });
        }
        this.loading = false;
      }, response => { 
        this.handleMessage({ message: 'There was an error updating the template on the provider!', alertClass: 'danger' });
        this.loading = false;
      });
  }

  handleMessage(rawMessage) {
    this.messages = this.fe.updateMessages(this.messages, rawMessage);
    if (rawMessage.error) console.error(rawMessage.error);
  }

}

export default {
  bindings: {
    hookType: "<",
    onCancel: "&"
  },
  templateUrl: "providers/salesforce/sf-webhooks/sf-webhooks.component.html",
  controller: SfWebhooksCtrl
};
